import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';

const styles = theme => ({
  root: {
    width: '100%'
  },
  subheader: {
    textTransform: 'uppercase',
    fontSize: '1em',
    letterSpacing: '.25em',
    lineHeight: '1.6em',
  }
});

class FooterSection extends React.Component {
  render() {
    const { classes, items, subheader } = this.props;

    return (
        <List subheader={<ListSubheader className={classes.subheader}>{subheader}</ListSubheader>} className={classes.root} dense={true}>
            {items.map((item, i) => (
                <ListItem component={item.link ? 'a' : undefined} button={!!item.link} href={item.link || undefined} key={i}>
                    <ListItemText primary={item.label || <item.component />} />
                </ListItem>
            ))} 
        </List>
    );
  }
}

FooterSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FooterSection);